// extracted by mini-css-extract-plugin
module.exports = {"Container":"DashboardViewsCards_Container__3xv9N","button":"DashboardViewsCards_button__72TS4","Card":"DashboardViewsCards_Card__PTEvz"};